import { DateTime } from 'luxon'

const defaultState = {
  data: null,
  lastRetrieveFinished: null
}
export default function permissionsV2(state = defaultState, action) {
  switch (action.type) {
    case 'permission-v2/fetch-success':
      state = {
        ...state,
        ...{
          permissionsDocument: action.response?.entries,
          lastRetrieveFinished: DateTime.local().toSeconds()
        }
      }
      break
  }

  return state
}
